import Footer from "../../components/common/footer";
import HeaderTwo from "../../components/common/headerTwo";
import { Helmet } from "react-helmet";
import Offer3TrawaSiew from "../../components/offer/3trawaSiew";

function K1MulczerLesny() {
  return (
    <>
      <Helmet>
        <title>Zakładanie trawników z siewu na przygotowanym gruncie | Gdańsk, Gdynia, Kaszuby</title>
        <meta name="title" content="Zakładanie trawników z siewu na przygotowanym gruncie | Gdańsk, Gdynia, Kaszuby" />
        <meta
          name="description"
          content="Trwałe zakładanie trawnika metodą siewu z doborem nasion do gleby i nasłonecznienia. Kompleksowe usługi w Gdańsku, Gdyni, Wejherowie, Kartuzach i na Kaszubach."
          key="desc"
        />
        <meta
          property="og:title"
          content="Zakładanie trawników z siewu na przygotowanym gruncie | Gdańsk, Gdynia, Kaszuby"
        />
        <meta
          property="og:description"
          content="Trwałe zakładanie trawnika metodą siewu z doborem nasion do gleby i nasłonecznienia. Kompleksowe usługi w Gdańsku, Gdyni, Wejherowie, Kartuzach i na Kaszubach."
        />
        <meta
          property="og:image"
          content="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/logo-white-10.55.05.png"
        />
      </Helmet>
      <HeaderTwo />
      <main className="relative z-40">
        <Offer3TrawaSiew />
      </main>
      <Footer />
    </>
  );
}
export default K1MulczerLesny;
